import { Alert, AlertTitle, Box, Button, Typography } from "@mui/material";
import { downloadFileFromUrl } from "../../../services/downloadFile";

interface Props {
  fileSrc: string;
  errorMessage: string;
  errorDetails?: string;
  preventDownload?: boolean;
}

const PdfDocumentError = ({ fileSrc, errorMessage, errorDetails, preventDownload }: Props) => {
  const handleDownloadFile = async () => {
    await downloadFileFromUrl(fileSrc);
  };

  return (
    <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
      <Alert
        severity="error"
        variant="outlined"
        sx={{ position: "relative", "&.MuiPaper-root": { height: "auto", width: "100%" } }}
      >
        <AlertTitle>{errorMessage}</AlertTitle>

        {errorDetails && <Typography variant="caption">{errorDetails}</Typography>}

        {!preventDownload && (
          <Button
            variant="outlined"
            color="inherit"
            sx={{ position: "absolute", right: 12, top: 12, py: 0 }}
            onClick={handleDownloadFile}
          >
            Download File
          </Button>
        )}
      </Alert>
    </Box>
  );
};

export default PdfDocumentError;
